import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Records")
  ])
], -1)
const _hoisted_2 = { class: "card-body pt-0 pb-5" }
const _hoisted_3 = { class: "col-lg-8 fv-row" }
const _hoisted_4 = { style: {"display":"none"} }
const _hoisted_5 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_6 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_7 = { class: "indicator-label" }
const _hoisted_8 = { class: "indicator-progress" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-4 ${_ctx.cardClasses}`)
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Datatable, {
        "table-header": _ctx.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        "rows-per-page": 10,
        "enable-items-per-page-dropdown": false
      }, {
        "cell-name": _withCtx(({ row: ireSizesValues }) => [
          _createTextVNode(_toDisplayString(ireSizesValues.name), 1)
        ]),
        "cell-value": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              class: "form-control form-control-solid",
              type: "number",
              placeholder: _ctx.translate('value'),
              modelValue: ireSizesValues.value,
              "onUpdate:modelValue": ($event: any) => ((ireSizesValues.value) = $event),
              onChange: ($event: any) => (_ctx.changeTableData(ireSizesValues)),
              name: "value"
            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "onChange"])
          ])
        ]),
        "cell-actions": _withCtx(({ row: ireSizesValues }) => [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(ireSizesValues.value), 1)
        ]),
        _: 1
      }, 8, ["table-header", "table-data", "loading"])
    ], 512), [
      [_vShow, _ctx.areaId > 0]
    ]),
    _createVNode(_component_Form, {
      class: "form",
      onSubmit: _ctx.onSubmitUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            type: "reset",
            class: "btn btn-white btn-active-light-primary me-2"
          }, _toDisplayString(_ctx.translate('discard')), 1),
          (_ctx.can('update', 'instant-rent-estimator'))
            ? (_openBlock(), _createElementBlock("button", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_9
                ])
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ], 2))
}